import axios from './axios';

// Admin/General API methods (for admin use)
// Get all vendor expenses with optional filters
export const getAllVendorExpenses = async (filters = {}) => {
    try {
        const response = await axios.get('/vendor-expenses', { params: filters });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get expenses for a specific vendor by vendor ID
export const getVendorExpenses = async (vendorId, depositId = null) => {
    try {
        const params = { vendor_id: vendorId };
        if (depositId) {
            params.deposit_id = depositId;
        }
        const response = await axios.get(`/vendor-expenses/vendor/${vendorId}`, { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get expenses for a specific deposit
export const getDepositExpenses = async (depositId) => {
    try {
        const response = await axios.get(`/vendor-expenses/deposit/${depositId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Create a new expense record (admin)
export const addVendorExpense = async (expenseData) => {
    try {
        const response = await axios.post('/vendor-expenses', expenseData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete an expense record by ID (admin)
export const deleteVendorExpense = async (id) => {
    try {
        const response = await axios.delete(`/vendor-expenses/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Vendor-specific API methods
// Get vendor's own expenses
export const getVendorOwnExpenses = async (filters = {}) => {
    try {
        const response = await axios.get('/vendor/expenses', { params: filters });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Create a new expense record for vendor
export const createVendorExpense = async (expenseData) => {
    try {
        const response = await axios.post('/vendor/expenses', expenseData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get a single expense record by expense ID for vendor
export const getVendorExpenseById = async (id) => {
    try {
        const response = await axios.get(`/vendor/expenses/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update an existing expense record for vendor
export const updateVendorExpense = async (id, expenseData) => {
    try {
        const response = await axios.put(`/vendor/expenses/${id}`, expenseData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete an expense record by ID for vendor
export const deleteVendorExpenseRecord = async (id) => {
    try {
        const response = await axios.delete(`/vendor/expenses/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}; 